export const MaxLength = {
    ADDRESS_NAME: 50,
    DETAIL_ADDRESS: 50,
    DELIVERY_MEMO: 100,
    RECEIVER_NAME: 50,
    PHONE_NUMBER: 4,
    ENTRY_MEMO: 50,
    PICKUP_MEMO: 50,
    FAMILY_PAY_MEMO: 50,
    TEXT_AREA: 500,
} as const

export const FamilyPayCheckoutTitle = '승인결제'
